import React from "react";
import Typography from "@material-ui/core/Typography";

export const DiversityStatement = ({ refProp }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>Diversity Statement</u>
      </Typography>

      <p>
        Combined Arms as a community supports LGBT+ rights, People of Colour and
        other minority groups. You are welcome and valued here, no matter who
        you are.
      </p>
      <p>Trans Rights are Human Rights. Black Lives Matter. Nazis go home.</p>
    </div>
  );
};

export default DiversityStatement;
